'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  show: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ChangeDocumentTypeConfirmModal = ({ show, onConfirm, onCancel }: Props) => {
  const translate = useTranslate('kyc_form.change_document_type_confirm_modal')

  return (
    <Dialog
      show={show}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('actions.confirm'),
          style: Dialog.ActionStyling.Filled,
          callback: onConfirm,
        },
        {
          text: translate('actions.cancel'),
          style: Dialog.ActionStyling.Flat,
          callback: onCancel,
        },
      ]}
    />
  )
}

export default ChangeDocumentTypeConfirmModal
